/**
 * CollapsibleSection - 通用可折叠区域组件
 *
 * 为配置面板提供统一的折叠展开交互体验
 */

import { ChevronDown, ChevronRight } from "lucide-react";
import { ReactNode } from "react";

interface CollapsibleSectionProps {
  title: string;
  isCollapsed: boolean;
  onToggle: () => void;
  children: ReactNode;
  className?: string;
}

export function CollapsibleSection({
  title,
  isCollapsed,
  onToggle,
  children,
  className = "",
}: CollapsibleSectionProps) {
  return (
    <div className={`flex flex-col gap-3 ${className}`}>
      {/* 可折叠的标题栏 */}
      <div
        className="flex items-center justify-between cursor-pointer hover:bg-muted/30 rounded-md p-2 -m-2 transition-colors"
        onClick={onToggle}
      >
        <div className="text-xs font-medium text-foreground">{title}</div>
        {isCollapsed ? (
          <ChevronRight className="w-4 h-4 text-muted-foreground" />
        ) : (
          <ChevronDown className="w-4 h-4 text-muted-foreground" />
        )}
      </div>

      {/* 内容区域 - 可折叠 */}
      {!isCollapsed && (
        <div className="flex flex-col pb-1 gap-3 animate-in slide-in-from-top-2 duration-200">
          {children}
        </div>
      )}
    </div>
  );
}
